import React, { useState } from 'react';
import { X, Star, ListChecks } from 'lucide-react';

const MARKETS = ['1', 'X', '2', '1X', 'X2', 'Over 1.5', 'Under 1.5', 'Over 2.5', 'Under 2.5', 'Over 3.5', 'Under 3.5', 'Goal', 'No Goal', 'Multigol 1-3', 'Multigol 2-4', 'Multigol 3-6'];

// Star tap while a selection is active: add to "La mia selezione" (with market) or classic favourites.
export const StarChoiceModal = ({ open, onClose, onFavorite, onAddToSelection, following, onFollow }) => {
  const [step, setStep] = useState('choice');
  if (!open) return null;
  const close = () => { setStep('choice'); onClose(); };
  return (
    <div className="fixed inset-0 z-[90] bg-black/80 backdrop-blur-sm flex items-end sm:items-center justify-center p-4" onClick={close} data-testid="star-choice-modal">
      <div onClick={(e) => e.stopPropagation()} className="relative bg-[#111] border border-[#F5A623]/20 rounded-3xl w-full max-w-md p-5">
        <button onClick={close} className="absolute top-4 right-4 text-gray-400 hover:text-white" data-testid="star-choice-close-btn"><X className="w-5 h-5" /></button>
        {step === 'choice' ? (
          <>
            <h2 className="text-lg font-black text-white mb-4" style={{ fontFamily: 'Barlow Condensed' }}>DOVE VUOI AGGIUNGERLA?</h2>
            <div className="space-y-2.5">
              <button onClick={() => setStep('market')} className="w-full p-3.5 rounded-2xl bg-[#F5A623] text-[#1A1A1A] font-black flex items-center gap-3" data-testid="star-choice-selection-btn">
                <ListChecks className="w-5 h-5" /> Alla mia selezione
              </button>
              <button onClick={() => { onFavorite(); close(); }} className="w-full p-3.5 rounded-2xl bg-[#1A1A1A] border border-white/10 text-white font-bold flex items-center gap-3" data-testid="star-choice-favorite-btn">
                <Star className="w-5 h-5 text-[#F5A623]" /> Ai preferiti
              </button>
              <button onClick={() => { onFollow(); close(); }} className="w-full p-3.5 rounded-2xl bg-[#1A1A1A] border border-white/10 text-white font-bold flex items-center gap-3" data-testid="star-choice-follow-btn">
                <span className="w-5 text-center">🔔</span> {following ? 'Notifiche attive' : 'Attiva notifiche'}
              </button>
            </div>
          </>
        ) : (
          <>
            <h2 className="text-lg font-black text-white mb-1" style={{ fontFamily: 'Barlow Condensed' }}>SCEGLI L'ESITO</h2>
            <p className="text-xs text-gray-400 mb-4">Quale esito hai inserito nella tua selezione?</p>
            <div className="grid grid-cols-4 gap-2">
              {MARKETS.map((m) => (
                <button key={m} onClick={() => { onAddToSelection(m); close(); }}
                  className="py-2 rounded-xl bg-[#242424] border border-white/10 text-white text-[11px] font-bold active:scale-95 transition-transform hover:border-[#F5A623]/50"
                  data-testid={`star-choice-market-${m.replace(/[^a-z0-9]/gi, '-').toLowerCase()}`}>
                  {m}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default StarChoiceModal;
